import React from 'react';
import { SnackbarProvider } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';

interface INoteProps {
  children: any
}

const notistackRef: any = React.createRef();
const onClickDismiss = (key: any) => () => {
  notistackRef.current.closeSnackbar(key);
};

const NotificationWrapper: React.FC<INoteProps> = ({ children }) => {
  return (
    <SnackbarProvider maxSnack={6}
      ref={notistackRef}
      action={(key: any) =>
        <Button onClick={onClickDismiss(key)}>
          <CloseIcon />
        </Button>
      }>
      {children}
    </SnackbarProvider>
  );
};
export default NotificationWrapper;
